export default __webpack_public_path__ + "static/g-collab-6554fd6efb595718346dffc1bb575e3e.jpg";